import { render, staticRenderFns } from "./EditTruck.vue?vue&type=template&id=9ff62d1e&scoped=true"
import script from "./EditTruck.vue?vue&type=script&lang=js"
export * from "./EditTruck.vue?vue&type=script&lang=js"
import style0 from "./EditTruck.vue?vue&type=style&index=0&id=9ff62d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff62d1e",
  null
  
)

export default component.exports